import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDaznComponent } from './simple-icons-dazn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDaznComponent ],
    exports:      [ SimpleIconsDaznComponent ],
    bootstrap:    []
})
export class SimpleIconsDaznModule {}
